import { RouterProvider } from 'react-router-dom';
import 'src/utils/DayJsInit';
import { DefaultTheme, ThemeProvider } from 'styled-components';

import { AppLoading } from './AppLoading';

import { FeatureFlagsProvider } from '@speeki/feature-flags';
import { WebThemeProvider } from '@speeki/theme';

import { GlobalStyledComponent } from '@components/_global/GlobalStyle/GlobalStyledComponent';

import { router } from '@services/RouteService/router';

import { ApolloProvider } from '@apollo/client';
import { client } from '@boot/apolloClient';

export const AppInitializer = () => {
    return (
        <FeatureFlagsProvider>
            <ApolloProvider client={client}>
                <WebThemeProvider variant="default">
                    {/* // NOTE: Overwrite default theme fonts */}
                    <ThemeProvider
                        theme={
                            {
                                font: {
                                    primary: `'DM Sans', sans-serif`,
                                    secondary: `'DM Sans', sans-serif`,
                                },
                            } as DefaultTheme
                        }
                    >
                        <GlobalStyledComponent />
                        <AppLoading>
                            <RouterProvider router={router} />
                        </AppLoading>
                    </ThemeProvider>
                </WebThemeProvider>
            </ApolloProvider>
        </FeatureFlagsProvider>
    );
};
